import FullWidthLoader from "./FullWidthLoader";
import { useAppSelector } from "../../Redux/app/hooks";
import CommonSnackBar from "./CommonSnackBar";
import { RootState } from "@/Redux/Store";

export default function CommonActionsWraper() {
    const fullPageLoaderOpen = useAppSelector(
        (state: RootState) => state?.app?.common?.fullPageLoaderOpen
    );
    return (
        <>
            {fullPageLoaderOpen && <FullWidthLoader open={fullPageLoaderOpen} />}
            <CommonSnackBar />
        </>
    );
}
